<template>
  <div>
    <hr/>
    <p>
      <strong>{{ $t('contract.working_conditions.headline') }}</strong>
    </p>

    <ul>
      <li v-if="conditions.shift">{{ $t('contract.working_conditions.shift.label') }}</li>
      <li v-if="conditions.inconvenient">{{ $t('contract.working_conditions.inconvenient.label') }}</li>
      <li v-if="conditions.irregular">{{ $t('contract.working_conditions.irregular.label') }}</li>
      <li v-if="conditions.timeoff">{{ $t('contract.working_conditions.timeoff.label') }}</li>
    </ul>

    <p v-if="conditions.inconvenient || conditions.irregular" class="mt-2">{{ $t('contract.working_conditions.paragraphs.first') }}</p>
    <hr />
  </div>
</template>

<script>
export default {
  computed: {
    conditions() {
      return this.$store.state.contract.workingConditions;
    }
  }
};
</script>

